import { Game } from '../game.js';

export class SafeAreas
{
  public static renderTopSafeAreaOverlay( ctx: CanvasRenderingContext2D ): void
  {
    const safe_area_top = Game.safeAreaTop();

    if ( safe_area_top <= 0 )
      return;

    ctx.save();

    const overlay_x = 0 - Game.safeAreaLeft();
    const overlay_y = 0;
    const overlay_width = Game.screenW() + Game.safeAreaLeft() + Game.safeAreaRight();
    const overlay_height = safe_area_top + 4;

    const blur_height = 5;
    const main_height = overlay_height - blur_height;

    ctx.fillStyle = 'rgba(4, 56, 124, 0.34)';
    ctx.fillRect( overlay_x, overlay_y, overlay_width, main_height );

    const gradient = ctx.createLinearGradient( 0, overlay_y + main_height, 0, overlay_y + overlay_height );
    gradient.addColorStop( 0, 'rgba(4, 56, 124, 0.34)' );
    gradient.addColorStop( 1, 'rgba(4, 56, 124, 0)' );

    ctx.fillStyle = gradient;
    ctx.fillRect( overlay_x, overlay_y + main_height, overlay_width, blur_height );

    ctx.restore();
  }

  public static renderBottomSafeAreaOverlay( ctx: CanvasRenderingContext2D, bottom_y: number = Game.screenH() ): void
  {
    const safe_area_bottom = Game.safeAreaBottom();

    if ( safe_area_bottom <= 0 )
      return;


    ctx.save();
    const overlay_x = 0;
    const overlay_y = bottom_y - safe_area_bottom;
    const overlay_width = Game.screenW();
    const overlay_height = safe_area_bottom;

    const blur_height = 5;
    const main_height = overlay_height - blur_height;

    ctx.fillStyle = 'rgba(0,0,0,0.24)';
    ctx.fillRect( overlay_x, overlay_y + blur_height, overlay_width, main_height );

    const gradient = ctx.createLinearGradient( 0, overlay_y + blur_height, 0, overlay_y );
    gradient.addColorStop( 0, 'rgba(0,0,0,0.24)' );
    gradient.addColorStop( 1, 'rgba(0, 0, 0, 0)' );

    ctx.fillStyle = gradient;
    ctx.fillRect( overlay_x, overlay_y, overlay_width, blur_height );

    ctx.restore();
  }

  public static renderBothSafeAreaOverlays( ctx: CanvasRenderingContext2D ): void
  {
    SafeAreas.renderTopSafeAreaOverlay( ctx );
    SafeAreas.renderBottomSafeAreaOverlay( ctx );
  }
}
